<template>
  <v-alert
    v-if="isLive"
    type="error"
    color="red darken-3"
    dark
    dense
    class="sim-dev-banner mb-0"
    icon="mdi-cellphone-wireless"
    tile
  >
    <strong>LIVE &mdash; this participant is routed to the real number.</strong>
    Prompts and replies sent from here go to
    <strong>{{ phoneLabel }}</strong> through the carrier. Nothing on this
    screen is fabricated.
  </v-alert>
  <v-alert
    v-else
    type="warning"
    color="amber darken-2"
    dark
    dense
    class="sim-dev-banner mb-0"
    icon="mdi-alert-circle-outline"
    tile
  >
    <strong>DEV / SIMULATED &mdash; not a real phone.</strong>
    Messages here are fabricated by the SMS simulator. No carrier, no real SMS,
    no charges.
  </v-alert>
</template>

<script>
import phoneFormat from '@/helpers/phoneFormat'

/**
 * Amber when the backend would route this participant to the simulator, red
 * when it would route to AWS (ROUTED mode with the allowlist + flag both on,
 * or provider AWS). `deliveryRoute` comes from GET /admin/sms-sim/state.
 */
export default {
  name: 'SimulatorDevBanner',
  props: {
    deliveryRoute: {
      type: String,
      default: null, // 'MOCK' | 'AWS' | null (unknown yet -> treated as simulated)
    },
    phone: {
      type: String,
      default: null,
    },
  },
  computed: {
    isLive() {
      return this.deliveryRoute === 'AWS'
    },
    phoneLabel() {
      return (
        (this.phone && phoneFormat.phoneUsFormat(this.phone)) ||
        this.phone ||
        'the participant'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.sim-dev-banner {
  border-radius: 0;
}
</style>
